<template>
    <el-drawer
        title="调整库存"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
			<!-- <div class="color-warning">
				<p>库存数据为票数，缺票根据为人数</p>
				<p>提交前请先选择是增加还是减少剩余库存</p>
				<p>请注意：由于时效的原因，你当前看到的剩余票数可能已经产生变动</p>
			</div> -->
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
                class="MT10"
            >
				<el-form-item v-if="itemData && itemData.ticketName">
				    <span slot="label">当前票品:</span>
				    {{ itemData && itemData.ticketName }}  <span class="ML10">￥{{itemData && itemData.sellPrice}}</span>
				</el-form-item>
				<el-form-item>
					<el-table						
					    v-if="itemData"
					    :data="[1]"
					    style="width: 100%"
					    size="small"
					    border
					    header-row-class-name="page-list-table"
					>
					    <el-table-column label="总库存">
					        <template>{{ itemData.totalNum }}</template>
					    </el-table-column>
					    <el-table-column label="已销售">
					        <template>{{itemData.sellNum + itemData.successCount}}</template>
					    </el-table-column>
					    <el-table-column label="待支付">
					        <template>{{itemData.occupyNum}}</template>
					    </el-table-column>
					    <el-table-column label="剩余可售">
					        <template><span :class="itemData.leftNum < 0 ? 'color-danger' : ''">{{itemData.leftNum}}</span></template>
					    </el-table-column>
						<el-table-column label="候补库存">
						    <template>{{itemData.altLeftNum}}</template>
						</el-table-column>
						<el-table-column label="候补中">
						    <template>{{itemData.amidCount}}</template>
						</el-table-column>
						<el-table-column label="缺票">
						    <template>{{itemData.lackTicketsNum}}人</template>
						</el-table-column>
					</el-table>
					<div class="lineH25">
						库存数据为票数，缺票根据为<span class="color-danger">人数</span></br>
						提交前请先选择是增加还是减少剩余库存</br>
						请注意：由于时效的原因，你当前看到的剩余票数可能已经产生变动
					</div>
				</el-form-item>
                <el-form-item prop="type">
                    <span slot="label">调整类型: <small>提交前请先选择是增加还是减少剩余库存</small></span>
                    <el-radio-group v-model="formDatas.type" size="medium">
                        <el-radio :label="1" border>增加</el-radio>
                        <el-radio :label="2" border>减少</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="num" label="剩余票数:">
                    <!-- <el-input v-model="formDatas.num" type="number" size="medium" @input="changeStock" @change="changeStock"></el-input> -->
                    <el-input-number style="width:100%" v-model="formDatas.num" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium"  placeholder="请输入调整数量"></el-input-number>
                </el-form-item> <!-- isStockToAlternate  0 自动回到普通库存，进行正常售卖 1保留在候补库存，即不进行正常售卖，仅留给后续参与候补的用户 -->
				<div class="color-danger" v-if="formDatas.type ==1 && itemData && itemData.isSoldOut == 1">
					<p>注意：当前票品已开启强制售罄，即使添加了库存也暂时无法售卖，也无法匹配候补订单</p>
				</div>
				<div class="color-danger" v-if="formDatas.type ==1 && itemData && itemData.isOpenAlternate == 1 && itemData.isStockToAlternate == 1">					
					<p>注意：当前票品开启了候补，增加的库存只会用于匹配给候补用户</p>
				</div>
				<div class="color-danger" v-if="formDatas.type ==1 && itemData && itemData.isOpenAlternate == 1 && itemData.isStockToAlternate == 0">					
					<p>注意：当前票品开启了候补，增加的库存会优先匹配给候补用户，之后如有余票会回到普通库存正常售卖</p>
				</div>
            </el-form>
            
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确 认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {
    type:1,
    num: undefined
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultData
            },
            rules:{
                num:[{ required: true, message: "请填写增/减数量",trigger:"change"}]
            },
            total:0,
            itemData: null
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultData
            }
        },
        show(data){
			console.log(data)
            this.itemData = data;			
            this.drawerShow = true;
        },
        changeStock(){
            this.total = this.formDatas.type == 1 ? 
                parseInt(this.itemData.totalNum) + parseInt(this.formDatas.num || 0) : 
                parseInt(this.itemData.totalNum) - parseInt(this.formDatas.num || 0);
            this.itemData.leftNum = this.total - parseInt(this.itemData.sellNum || 0) - parseInt(this.itemData.occupyNum || 0);
        },
        //表单提交
        submitForm() {
			
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/activity/adjustStocks',
                        data: {
                            ...this.formDatas,
                            goodsId: this.itemData.activityId,
                            skuId: this.itemData.id
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit("onUpdate");
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
	.lineH25{
		line-height: 25px;
		margin-top: 20px;
	}
</style>